export interface TtsProgress {
    corpusId: string;
    bookId: string;
    chapter: number;
    pageIndex: number;
    chunkIndex: number;
    snippet: string;
    timestamp: number;
    provider: string;
}

const STORAGE_KEY = 'wikiboox.tts_progress';

export function saveTtsProgress(progress: TtsProgress) {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        const map = raw ? JSON.parse(raw) : {};
        const key = `${progress.corpusId}:${progress.bookId}`;
        map[key] = progress;
        localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
    } catch { }
}

export function loadTtsProgress(corpusId: string, bookId: string): TtsProgress | null {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        const map = JSON.parse(raw);
        return map[`${corpusId}:${bookId}`] || null;
    } catch { return null; }
}

export function clearTtsProgress(corpusId: string, bookId: string) {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return;
        const map = JSON.parse(raw);
        const key = `${corpusId}:${bookId}`;
        if (map[key]) {
            delete map[key];
            localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
        }
    } catch { }
}
